require('./watchListView.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter, Prompt } = require('react-router-dom');

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { formatText, getFinalTitle, FormattedText } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('commonsComponents/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const WatchList = require('./watchList/watchList');
const EventModals = require('./eventModals/eventModals');
const { BrokerMarketsTrend } = require('components/broker/brokerMarketsTrend/brokerMarketsTrend');
const BrokerNewsColumn = require('components/commons/broker/news/brokerNewsColumn');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const {
    BrokerTodaysMainStocks
} = require('components/broker/brokerTodaysMainStocks/brokerTodaysMainStocks');
const {
    BrokerMostPopularOfMonth
} = require('components/broker/brokerMostPopularOfMonth/brokerMostPopularOfMonth');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const BrokerWatchlistModal = require('components/broker/brokerWatchlistModal/brokerWatchlistModal');
const { BrokerClientWarningModal } = require('components/broker/commons/brokerClientWarningModal/brokerClientWarningModal');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const { BrokerNoStockAccountModal } = require('components/broker/brokerSearchResults/brokerNoStockAccountModal');

// @actions
const BrokerWatchlistActions = require('actions/brokerWatchlist');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const newsActions = require('actions/brokerNews');
const brokerNoStockAccountModalActions = require('actions/brokerNoStockAccountModal');

// @ constants
const {
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_ERROR_URL
} = require('constants/index');
const {
    getDummyData,
    MAX_LIST_COUNT,
    INITIAL_WATCHLIST_EDIT_ID
} = require('./constant');
const {
    TREND
} = require('constants/flagBasedFeatures');

class WatchListView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nextLocation: null,
            isModalOpen: false,
            modalType: 'discard',
            titleEditListId: INITIAL_WATCHLIST_EDIT_ID,
            hasAbondantChanges: false,
            createListButtonClick: false,
            deleteListId: '',
            isBlockingRouteChange: false,
        }

        this.toggleModal = this.toggleModal.bind(this);
        this.setListName = this.setListName.bind(this);
        this.setEditId = this.setEditId.bind(this);
        this.handleDeleteList = this.handleDeleteList.bind(this);
        this.onHandleAddToExistingList = this.onHandleAddToExistingList.bind(this);
        this.handleDeleteProduct = this.handleDeleteProduct.bind(this);
        this.saveListName = this.saveListName.bind(this);
        this.handleWatchlistModalToggle = this.handleWatchlistModalToggle.bind(this);
        this.cancelWatchlistModal = this.cancelWatchlistModal.bind(this);
        this.onSubmitNewList = this.onSubmitNewList.bind(this);
        this.handleClickOfOtherModal = this.handleClickOfOtherModal.bind(this);
        this.handleStockContractClick = this.handleStockContractClick.bind(this);
        this.handleWatchlistModalForSearchLink = this.handleWatchlistModalForSearchLink.bind(this);
        this.isNameChanged = false;
        this.listIdTobeDeleted = INITIAL_WATCHLIST_EDIT_ID;
        this.tempararyTitleEditListId = INITIAL_WATCHLIST_EDIT_ID;
        this.deleteProductData = {};
    }

    componentDidMount() {
        this.props.getUserWatchlist();
    }

    toggleModal(selector, listId) {
        let canModalOpen;
        switch (selector) {
            case 'discard':
                canModalOpen = !this.state.isModalOpen && this.isNameChanged;
                this.tempararyTitleEditListId = listId;
                this.setState({
                    modalType: 'discard',
                    isModalOpen: canModalOpen,
                });
                return canModalOpen;
            case 'deleteList':
                this.setState({
                    modalType: 'deleteList',
                    isModalOpen: !this.state.isModalOpen
                });
                break;
            case 'deleteProduct':
                this.setState({
                    modalType: 'deleteProduct',
                    isModalOpen: !this.state.isModalOpen
                });
                break;
            default:
                this.setState({
                    isModalOpen: !this.state.isModalOpen
                });
        }
    }

    setEditId(listId) {
        if (listId === INITIAL_WATCHLIST_EDIT_ID) {
            this.isNameChanged = false;
            this.setState({
                hasAbondantChanges: false
            });
        }
        this.setState({
            titleEditListId: listId
        });
    }

    setListName(isNameChanged) {
        this.isNameChanged = isNameChanged;
    }

    handleDeleteList(listId) {
        this.listIdTobeDeleted = listId;
        this.setState({
            deleteListId: listId,
        });
        this.toggleModal('deleteList');
    }

    handleDeleteProduct(id, isin, micCode, productName, status, deleteProductLandingMsg, productType, productKey) {
        this.props.deleteProductFromList(
            id,
            isin,
            micCode,
            productName,
            status,
            deleteProductLandingMsg,
            productType,
            productKey
        );
    }

    onHandleAddToExistingList(id, isin, micCode, listName, productType, addProductFromLandingPage) {
        this.props.addToExistingList(
            id,
            isin,
            micCode,
            listName,
            productType,
            addProductFromLandingPage
        );
    }

    handleStockContractClick(nextLink) {
        const { immBrokerClientWarningModal, showClientWarningModal, immStocksContracts, showNoStockAccountModal, history } = this.props;
        // Starts listening for redirections
        const hasNoStockContracts = immStocksContracts.isEmpty();
        const clientPersonalInfoUpdated = immBrokerClientWarningModal.get('clientPersonalInfoUpdated');
        const isFetching = immBrokerClientWarningModal.get('isFetching');
        const isFetched = immBrokerClientWarningModal.get('isFetched');

        if (isFetched && !isFetching) {
            if (!clientPersonalInfoUpdated) {
                showClientWarningModal(history);
                this.setState({
                    nextLocation: nextLink,
                    isBlockingRouteChange: true
                });
            }
            else if (hasNoStockContracts) {
                showNoStockAccountModal();
            }
            else {
                history.push(nextLink);
            }
        } else if (!isFetched && !isFetching) {
            history.push(MYPROFILE_BROKER_ERROR_URL);
        }

        window.modalInstance = this;
    }

    buildMappingBreadcrumb() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('breadcrumb-yourInvestments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('breadcrumb-breadcrumb_brokerWatchList')
            }
        ];
        return mappingBreadcrumb;
    }


    buildWatchList() {
        const {
            immBrokerWatchlist,
            listSelectedForParam,
            requestEditWatchList,
            sortWatchList,
            match: { params: { listId: _listId } }
        } = this.props;
        const watchlistContent = immBrokerWatchlist.get('watchlistContent');
        const isFetchinglist = immBrokerWatchlist.get('isFetchinglist');
        const editWatchListError = immBrokerWatchlist.get('editWatchListError');
        let listData, isDisabled;

        if (isFetchinglist) {
            return <LoadingSection />;
        } else if (watchlistContent.isEmpty()) {
            listData = getDummyData();
            isDisabled = true;
        } else {
            listData = watchlistContent;
        }

        const resultArray = [];
        listData.map((list, index) => {
            const listId = list.get('id');
            const isExpanded = !!listId ? (listId.toString() === _listId || (isDisabled && index === 0)) : false;

            resultArray.push(
                <WatchList
                    disabled={isDisabled}
                    isExpanded={isExpanded}
                    key={listId}
                    listData={list}
                    listSelectedForParam={listSelectedForParam}
                    requestEditWatchList={requestEditWatchList}
                    onDeleteWatchList={this.handleDeleteList}
                    onHandleDeleteProduct={this.handleDeleteProduct}
                    toggleModal={this.toggleModal}
                    setListName={this.setListName}
                    isTitleEditable={this.state.titleEditListId === list.get('id')}
                    setEditId={this.setEditId}
                    sortWatchList={sortWatchList}
                    editWatchListError={editWatchListError}
                    hasAbondantChanges={this.state.hasAbondantChanges}
                    watchlistContent={watchlistContent}
                    handleAddToExistingList={this.onHandleAddToExistingList}
                    onHandleStockContractClick={this.handleStockContractClick}
                />
            );
        });
        return resultArray;
    }

    handleWatchlistModalForSearchLink() {
        const { titleEditListId } = this.state;
        const isModalOpen = titleEditListId !== INITIAL_WATCHLIST_EDIT_ID;
        if (isModalOpen) {
            this.setState({
                modalType: 'discard',
                isModalOpen
            });
        } else {
            this.props.history.push('/myprofile/broker/explore/');
        }
    }

    createSubTitle() {
        const { immBrokerWatchlist } = this.props;
        const watchlistContent = immBrokerWatchlist.get('watchlistContent');
        let formatValue, linkText, injectedStrings;

        if (watchlistContent.isEmpty() && !immBrokerWatchlist.get('isFetchinglist')) {
            formatValue = 'brokerWatchList-brokerWatchList_subTitleDisabled';
            linkText = 'brokerWatchList-brokerWatchList_createListLink';
            injectedStrings = (
                <OKLink onClick={this.handleWatchlistModalToggle}>
                    <FormattedText value={linkText} />
                </OKLink>
            );
        } else {
            formatValue = 'brokerWatchList-brokerWatchList_subTitle';
            linkText = 'brokerWatchList-brokerWatchList_searchEngine';
            injectedStrings = (
                <OKLink onClick={this.handleWatchlistModalForSearchLink}>
                    <FormattedText value={linkText} />
                </OKLink>
            );
        }

        return (
            <FormattedTextWithComponents
                className="watch-list-view__sub-heading"
                value={formatValue}
                injectedComponents={[injectedStrings]}
            />
        );
    }

    configModalActions(modalType) {
        let actionsObject;
        switch (modalType) {
            case 'discard':
                actionsObject = {
                    leftButtonAction: () => {
                        this.toggleModal();
                        this.isNameChanged = false;
                        this.setEditId(INITIAL_WATCHLIST_EDIT_ID);
                        this.setState({
                            hasAbondantChanges: true,
                            titleEditListId: this.tempararyTitleEditListId
                        });
                    },
                    rightButtonAction: () => {
                        this.toggleModal();
                        this.setState({
                            createListButtonClick: false
                        });
                    }
                };
                break;
            case 'deleteList':
                actionsObject = {
                    leftButtonAction: () => {
                        this.toggleModal();
                        this.setState({
                            deleteListId: ''
                        });
                    },
                    rightButtonAction: () => {
                        this.props.deleteWatchList(this.listIdTobeDeleted);
                        this.toggleModal();
                        this.setState({
                            hasAbondantChanges: true,
                            deleteListId: ''
                        });
                    }
                };
                break;
            case 'deleteProduct':
                actionsObject = {
                    leftButtonAction: () => {
                        this.toggleModal();
                    },
                    rightButtonAction: () => {
                        this.props.deleteProductFromList(
                            this.deleteProductData.listData,
                            this.deleteProductData.isin
                        );
                        this.toggleModal();
                    }
                }
        }

        return actionsObject;
    }

    handleWatchlistModalToggle(event) {
        event.stopPropagation();
        this.setState({
            createListButtonClick: true,
            isModalOpen: this.state.titleEditListId !== INITIAL_WATCHLIST_EDIT_ID
        });
        return false;
    }

    cancelWatchlistModal() {
        this.setState({
            createListButtonClick: false
        });
        this.props.resetWatchlistDetails();
    }

    saveListName(listName) {
        this.props.saveListName(listName);
    }

    onSubmitNewList() {
        this.props.createNewListName();
        this.setState({
            createListButtonClick: false
        });
    }

    handleWatchlistModal() {
        const { immBrokerWatchlist } = this.props;
        const { isModalOpen, createListButtonClick } = this.state;
        const watchlistContent = immBrokerWatchlist.get('watchlistContent');
        const listName = immBrokerWatchlist.get('listName');
        const isOpen = !isModalOpen && createListButtonClick;

        return (
            <BrokerWatchlistModal
                watchlistContent={watchlistContent}
                isModalOpen={isOpen}
                modifier={'createNewList'}
                saveListName={this.saveListName}
                listName={listName}
                handleCancelForModal={this.cancelWatchlistModal}
                handleContinueForNewList={this.onSubmitNewList}
            />
        )
    }

    handleClickOfOtherModal() {
        this.setState({
            modalType: 'discard',
            isModalOpen: this.state.titleEditListId !== INITIAL_WATCHLIST_EDIT_ID
        });
    }

    render() {
        const { immBrokerWatchlist } = this.props;
        const watchlistContent = immBrokerWatchlist.get('watchlistContent');
        const actionsObject = this.configModalActions(this.state.modalType);
        const subTitleElement = this.createSubTitle();
        const createListButtonDisabled = watchlistContent.size >= MAX_LIST_COUNT;
        const watchlistModal = this.handleWatchlistModal();
        let listButtonText = watchlistContent.isEmpty() ? 'brokerWatchList-brokerWatchList_createEmptyListText' : 'brokerWatchList-brokerWatchList_createListText';
        const editId = watchlistContent.findIndex((product) => {
            return product.get('id') === this.state.titleEditListId;
        });
        let editListName = watchlistContent.getIn([editId, 'name']);
        if (this.state.deleteListId) {
            const deleteId = watchlistContent.findIndex((product) => {
                return product.get('id') === this.state.deleteListId;
            });
            editListName = watchlistContent.getIn([deleteId, 'name']);
        }

        const createListButton = (
            <span>
                <OKButton
                    modifier="primary"
                    disabled={createListButtonDisabled}
                    onClick={this.handleWatchlistModalToggle}
                >
                    <FormattedText value={listButtonText} />
                </OKButton>
            </span>
        );

        let createListLinkOrMaximumListText;
        if (createListButtonDisabled) {
            createListLinkOrMaximumListText = (
                <FormattedText
                    className="watch-list-view__maximum-list-count-text"
                    value="brokerWatchList-brokerWatchList_maximumListCountText"
                />
            );
        } else {
            createListLinkOrMaximumListText = (
                <div className="watch-list-view__link">
                    <OKLink
                        extraClass="watch-list-view__create-list-link"
                        modifier="widget"
                        inverse={true}
                        onClick={this.handleWatchlistModalToggle}
                    >
                        <FormattedText value={listButtonText} />
                    </OKLink>
                </div>
            );
        }

        return (
            <React.Fragment>
                <Prompt message={() => false} when={this.state.isBlockingRouteChange} />
                <div className="grid-view">
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="transfers" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={this.buildMappingBreadcrumb()}
                                    finalTitle={getFinalTitle('breadcrumb-breadcrumb_brokerWatchList')}
                                >
                                    <div className="watch-list-view__action-button" onClick={this.handleClickOfOtherModal}>
                                        {createListButton}
                                    </div>
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="watch-list-view">
                                <h2 className="watch-list-view__heading">
                                    {formatText('brokerWatchList-brokerWatchList_title')}
                                </h2>
                                {subTitleElement}
                                {watchlistModal}
                                <div className="row">
                                    <div className="col-xs-8">
                                        <div className="row">
                                            <div className="col-md-12 grid-view--fix-cell-separation">
                                                {this.buildWatchList()}
                                                <BrokerClientWarningModal
                                                    nextLocation={this.state.nextLocation}
                                                    routerHookCallback={() => {
                                                        this.setState({ isBlockingRouteChange: false });
                                                    }}
                                                />
                                            </div>
                                            <div onClick={this.handleClickOfOtherModal}>
                                                <div className="col-md-12 grid-view--fix-cell-separation">
                                                    {createListLinkOrMaximumListText}
                                                </div>
                                                <div className="col-md-12 grid-view--fix-cell-separation watch-list-view__clear">
                                                    <BrokerMostPopularOfMonth />
                                                </div>
                                                <div className="col-md-12 grid-view--fix-cell-separation">
                                                    <BrokerTodaysMainStocks
                                                        onHandleBuyClick={this.handleStockContractClick}
                                                    />
                                                </div>
                                                <div className="col-md-12 grid-view--fix-cell-separation">
                                                    <BrokerNewsColumn
                                                        immBrokerNews={this.props.immBrokerNews}
                                                        requestNews={this.props.requestNews}
                                                        maxNews={2}
                                                        width="col-lg-6"
                                                        newsSection={false}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-4">
                                        <div className="row" onClick={this.handleClickOfOtherModal}>
                                            <div className="col-md-12 grid-view--fix-cell-separation">
                                                <CommercialAds path="broker/watchlist" type="banner-a" size="medium" section="watchlistBannerFirst" />
                                            </div>
                                            <FeatureTogglingRender notAllowedProductKey={TREND}>
                                                <div className="col-md-12 grid-view--fix-cell-separation">
                                                    <BrokerMarketsTrend
                                                        onHandleBuyClick={this.handleStockContractClick}
                                                    />
                                                </div>
                                            </FeatureTogglingRender>
                                            <div className="col-md-12 grid-view--fix-cell-separation">
                                                <CommercialAds path="broker/watchlist" type="banner-a" size="medium" section="watchlistBannerSecond" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <FormattedText
                                        className="col-xs-12 watch-list-view__info-source"
                                        value="brokerWatchList-brokerWatchList_investmentInformationSource"
                                    />
                                </div>
                                <div className="row grid-view__cross-selling">
                                    <div className="col-xs-12">
                                        <CommercialAds path="broker/general" type="cross-selling" />
                                    </div>
                                </div>
                                <EventModals
                                    editListName={editListName}
                                    isModalOpen={this.state.isModalOpen}
                                    modalType={this.state.modalType}
                                    handleToggleModal={this.toggleModal}
                                    actionsObject={actionsObject}
                                />
                            </div>
                        </div>
                    </div>
                    <BrokerNoStockAccountModal />
                </div>
            </React.Fragment>
        );
    }
}

WatchListView.propTypes = {
    addToExistingList: PropTypes.func,
    createNewListName: PropTypes.func,
    deleteProductFromList: PropTypes.func,
    deleteWatchList: PropTypes.func,
    listSelectedForParam: PropTypes.func,
    getUserWatchlist: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerClientWarningModal: PropTypes.object,
    immBrokerNews: PropTypes.object,
    immBrokerWatchlist: PropTypes.object,
    immStocksContracts: PropTypes.object.isRequired,
    match: PropTypes.object,
    requestEditWatchList: PropTypes.func,
    requestNews: PropTypes.func,
    resetWatchlistDetails: PropTypes.func,
    saveListName: PropTypes.func,
    showClientWarningModal: PropTypes.func,
    showNoStockAccountModal: PropTypes.func,
    sortWatchList: PropTypes.func
};
module.exports.constructor = WatchListView;
module.exports.WatchListView = connect(
    state => ({
        immBrokerWatchlist: state.brokerWatchlist,
        immBrokerClientWarningModal: state.brokerClientWarningModal,
        immBrokerNews: state.brokerNews,
        immStocksContracts: state.brokerStocksContract,
    }),
    {
        addToExistingList: BrokerWatchlistActions.addToExistingList,
        getUserWatchlist: BrokerWatchlistActions.getUserWatchlist,
        deleteWatchList: BrokerWatchlistActions.deleteWatchList,
        deleteProductFromList: BrokerWatchlistActions.deleteProductFromList,
        listSelectedForParam: BrokerWatchlistActions.listSelectedForParam,
        requestEditWatchList: BrokerWatchlistActions.requestEditWatchList,
        sortWatchList: BrokerWatchlistActions.sortWatchList,
        showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal,
        showNoStockAccountModal: brokerNoStockAccountModalActions.showModal,
        requestNews: newsActions.requestNews,
        saveListName: BrokerWatchlistActions.saveListName,
        resetWatchlistDetails: BrokerWatchlistActions.resetWatchlistDetails,
        createNewListName: BrokerWatchlistActions.createNewListName
    }
)(withRouter(WatchListView));
